import { change } from 'redux-form';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PortfolioControls from 'profile/components/portfolio/portfolio_controls';
import { fetchPortfolioEntries, getPortfolioFilters, savePortfolioFilters,
  getPortfolio } from 'profile/ducks/portfolio';

const mapStateToProps = (state, { params }) => {
  const portfolioPage = getPortfolio(state);

  return {
    profileUsername: params.profileUsername,
    filters: getPortfolioFilters(state),
    disabled: portfolioPage.editMode
  };
};

export default withRouter(connect(mapStateToProps, {
  fetchPortfolioEntries,
  savePortfolioFilters,
  change,
})(PortfolioControls));



// WEBPACK FOOTER //
// ./profile/containers/portfolio/portfolio_controls.jsx